import { Tab } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  function setTabFromHash() {
    if (location.hash) {
      const cleanHash = location.hash.replace(/[^a-zA-Z0-9-_]/g, '');
      const hashTab = '#' + cleanHash + '-tab';
      const desktopTrigger = document.querySelector(hashTab);
      const mobileOption = document.querySelector(`option[value="${hashTab}"]`);
      const parentTabSelect = mobileOption ? mobileOption.parentElement : null;

      if (parentTabSelect) {
        parentTabSelect.value = hashTab;
        parentTabSelect.dispatchEvent(new Event('change'));
      }
    }
  }

  window.addEventListener('hashchange', () => {
    setTabFromHash();
  });

  document.querySelectorAll('.tab-select').forEach((tabSelect) => {
    tabSelect.addEventListener('change', (evt) => {
      let selection = evt.currentTarget.selectedOptions[0];
      switch (selection.getAttribute('data-wf-type')) {
        case 'link':
          window.location = selection.value;
        break;
        case 'tab':
          Tab.getOrCreateInstance(document.querySelector(selection.value)).show();
          const cleanHash = selection.value.replace('-tab', '');
          window.location.hash = cleanHash;
        break;
      }
    })
  })

  setTabFromHash();
})
